import React, { Component } from 'react'
import Spinner from './Spinner'
import {Link} from 'react-static'
import {Form,FormGroup,Label,Input,Button} from 'reactstrap'

export default class SignInForm extends Component {
  constructor (props) {
    super(props)

    this.state = {
      isSubmitting: false,
      email: '',
      password: '',
      error: null
    }
  }

  onSubmit = event => {
    event.preventDefault()

    const { email, password } = this.state
    this.setState({isSubmitting: true})
    this.props.signin(email, password)
      .then(() => {
        this.setState({email: '', password: '', error: null, isSubmitting: false})
      })
      .catch(error => {
        this.setState({error, isSubmitting: false})
      })
  }

  render() {
    const isInvalid = this.state.password === '' || this.state.email === ''

    return (
      <div className="row">
        <div className="col-12">
          <Form onSubmit={this.onSubmit}>
            {this.state.error &&
              <p className="alert alert-danger">{this.state.error.message}</p>
            }
            <FormGroup row>
              <div className="col-12">
                <div className="input-group">
                  <div className="input-group-prepend">
                    <span className="input-group-text">
                      <i className="fas fa-envelope"/>
                    </span>
                  </div>
                  <Input
                    type="email"
                    name="email"
                    placeholder="email"
                    value={this.state.email}
                    onChange={e => this.setState({email: e.target.value})}/>
                </div>
              </div>
            </FormGroup>

            <FormGroup row>
              <div className="col-12">
                <div className="input-group">
                  <div className="input-group-prepend">
                    <span className="input-group-text">
                      <i className="fas fa-key"/>
                    </span>
                  </div>
                  <Input
                    type="password"
                    name="password"
                    placeholder='Passwort'
                    value={this.state.password}
                    onChange={e => this.setState({password: e.target.value})}/>
                </div>
              </div>
            </FormGroup>

            <div className="form-group text-right m-t-20">
              <div className="col-xs-12">
                <Button
                  type="submit"
                  color="primary"
                  disabled={isInvalid || this.state.isSubmitting}
                  className="btn-custom w-md waves-effect waves-light">
                  {this.state.isSubmitting ? 'Bitte warten...' : 'Anmelden'}
                </Button>
              </div>
            </div>

            <div className="form-group row m-t-30">
              <div className="col-sm-7">
                <Link to="/forgotpw">
                  <i className="fa fa-lock m-r-5"/>{' '}
                  Passwort vergessen?
                </Link>
              </div>

              <div className="col-sm-5 text-right">
                <Link to="/signup">Registrieren</Link>
              </div>
            </div>

          </Form>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// /Users/d064310/Development/playland/colorribbon/src/components/SignInForm.js